<template>
  <div class="tournament-list-detail">
    <div class="card is-primary is-outlined">
      <div class="card-content">
        <div class="top">
          <div class="date subtitle has-size-4">
            <span>{{ startDateFormatted }}</span>
          </div>
        </div>
        <p class="title">{{ tournament.name }}</p>
        <div v-if="tournament.genderGroups.length > 0 && tournament.genderGroups.indexOf('N/S') == -1" class="tag-wrapper">
          <span>Gender Brackets: </span>
          <gender-group-tags :tags="tournament.genderGroups"/>
        </div>
        <div class="tag-wrapper">
          <span>Number of Players: </span>
          <num-players-tags :tags="tournament.numberOfPlayers"/>
        </div>
        <div v-if="tournament.divisions.length > 0 && tournament.divisions.indexOf('N/S') == -1" class="tag-wrapper">
          <span>Divisions: </span>
          <division-tags :tags="tournament.divisions"/>
        </div>
		    <p style="margin-bottom: 0.5rem;"><span class="has-text-weight-semibold">Price: </span>${{ tournament.price }} per {{ signupAs.toLowerCase() }}</p>
        <registrations-list v-if="!tournament.externalLink" :tournament="tournament" style="margin-bottom: 0.75rem;"/>
        <div class="detail-buttons">
          <router-link :to="`/tournaments/${tournament.id}/details`" class="button is-info is-outlined is-rounded details-button">More Info</router-link>
          <router-link v-if="!tournament.externalLink" :to="`/tournaments/${tournament.id}/signup`" class="button is-success is-outlined is-rounded">Signup ({{ signupAs }})</router-link>
          <a v-if="tournament.externalLink" :href="tournament.externalLink" class="button is-external is-outlined is-rounded">Signup (External)</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GenderGroupTags from '@/components/GenderGroupTags.vue';
import DivisionTags from '@/components/DivisionTags.vue';
import NumPlayersTags from '@/components/NumPlayersTags.vue';
import RegistrationsList from '@/components/RegistrationsList.vue';

import tournamentDetails from '@/mixins/tournamentDetails';

import moment from 'moment'

export default {
  name: 'TournamentListDetail',
  components: {
    GenderGroupTags,
    DivisionTags,
    NumPlayersTags,
    RegistrationsList
  },
  mixins: [tournamentDetails],
  props: {
    tournament: {
      type: Object,
      required: true
    },
  },
  computed: {
    startDateFormatted() {
      return moment(this.tournament.startDate).format("MMMM Do");
    },
    signupAs() {
      return this.tournament.individualRegistration ? "Individual" : "Team";
    },
    hasRegistrationEnded() {
      let endsAt = moment(this.tournament.registrationEnds, "YYYY-MM-DD");
      let now = moment();
      return moment.duration(now - endsAt).days() <= 0;
    }
  }
}
</script>

<style lang="scss" scoped>
  .tournament-list-detail {
    margin: 1rem;
    text-align: left;

    .tags.multi-tags {
      justify-content: flex-start;
      align-items: flex-start;
      padding-left: 0;
      padding-right: 0;
      margin-bottom: 0.125rem;
    }

    ::v-deep .tag.multi-tag {
      border-width: 0.2px !important;
    }
  }
  .date {
    text-align: left;
    color: lighten(saturate(green, 3%), 3%);
    margin-bottom: 0.5rem;
  }
  .title {
    margin-bottom: 1rem;
  }
  .tag-wrapper {
    span {
      font-weight: 600;
    }
    .tags.multi-tags {
      display: inline !important;
    }
  }
  .detail-buttons {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    .button {
      margin-right: 0.5rem;
      margin-bottom: 0.5rem;
    }
    // padding-left: 16.5%;
    // padding-right: 16.5%;
  }
  p.title {
    font-size: 1.5rem;
  }
</style>